export default __webpack_public_path__ + "static/media/price-icon.c19ff740.svg";